// Third-party
import React from 'react';

// Utils
import { formatMessageWithLocale } from '../../../../utils/i18n';
import { DISCLAIMER_KEYS } from '../../../../utils/disclaimers/constants';
import { uniqueArray, enumerateArray } from '../../../../utils/objects';
import ComparisonItem from '@/types/comparison-item';
import Locale from '@/types/locale';

type Props = {
  items: ComparisonItem[];
  locale?: Locale;
};

const CustomProviderRiskRatingDisclaimer = ({ items, locale }: Props) => {
  const providers = items.reduce((acc, item) => {
    const { provider } = item.disclaimers?.[DISCLAIMER_KEYS.CUSTOM_PROVIDER_RISK_RATING].data;
    return provider ? uniqueArray(acc.concat(provider)) : acc;
  }, []);

  if (providers.length === 0) {
    return null;
  }

  return (
    <div className="disclaimer">
      {formatMessageWithLocale('Disclaimers.CustomProviderRiskRating.Message', locale, {
        provider: enumerateArray(providers, formatMessageWithLocale('Common.And')),
      })}
      &nbsp;
    </div>
  );
};

export default CustomProviderRiskRatingDisclaimer;
